import _ from 'lodash'
export const getPushToken = (state) => _.get(state, 'pushNotifications.token')